import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "How can digital marketing services increase my business revenue?",
    answer: `<p>Digital marketing drives revenue by leveraging targeted strategies like SEO, PPC, and content marketing to attract and convert high-quality leads.</p>`,
  },
  {
    question: "What are the key metrics to measure digital marketing success?",
    answer: `<p>Success in digital marketing is measured by KPIs such as conversion rates, ROI, customer acquisition cost, and engagement metrics.</p>`,
  },
  {
    question: "How does SEO improve my website's visibility?",
    answer: `<p>SEO enhances visibility by optimizing your website for search engines, improving rankings, and driving organic traffic from relevant searches.</p>`,
  },
  {
    question: "What makes PPC advertising effective for my business?",
    answer: `<p>PPC is effective because it delivers immediate visibility, targets specific audiences, and provides measurable results with a controlled budget.</p>`,
  },
  {
    question: "How can social media marketing boost brand awareness?",
    answer: `<p>Social media marketing builds brand awareness by engaging with your audience through tailored content and strategic interactions across platforms.</p>`,
  },
  {
    question: "What is the role of content marketing in digital strategy?",
    answer: `<p>Content marketing plays a crucial role by providing valuable, relevant content that attracts, engages, and converts your target audience, ultimately driving traffic and improving brand authority.</p>`,
  },
  {
    question: "How often should I update my digital marketing strategy?",
    answer: `<p>Your digital marketing strategy should be regularly reviewed and updated every 3-6 months to adapt to changing market trends, consumer behavior, and technological advancements.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Digital Marketing FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
